import 'font-awesome/css/font-awesome.min.css';

import './payout/PayoutView.sass';
import './success/SuccessView.sass';
import './competitive/InterviewView.sass';
import './competitive/CompetitiveView.sass';
import './participation/ParticpationForm.sass';
import './support/SupportView.sass';
